<form
  (submit)="submit()"
  class="sticky bottom-0 z-20 flex flex-col px-4 py-4 upper-shadow"
  [class.opaque]="paymentSummary.commisionVisible"
  [class.scrolled]="scrolled"
>
  <div class="flex flex-col mb-1 md:hidden" *ngIf="paymentSummary.commisionVisible">
    <div class="flex flex-row justify-between">
      <div class="text-gray-700">Kwota:</div>
      <div>
        <span class="text-primary-800">{{ paymentSummary.amount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}</span>
      </div>
    </div>
    <div class="flex flex-row justify-between">
      <div class="text-gray-700">Prowizja:</div>
      <div>
        <span class="text-primary-800">{{ paymentSummary.commission | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}</span>
      </div>
    </div>
  </div>

  <app-submit-button [ready]="submitReady" [loading]="submitted" class="flex-grow">
    PŁACĘ {{ paymentSummary.totalAmount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}
  </app-submit-button>
</form>
